jQuery(document).ready(function($) {

	$('.tab--link a').on('click', function(e){

		e.preventDefault();

		var id   = $(this).attr('href');
		var tabs = $(this).closest('.tabs');

		tabs.find('.tab--content').removeClass('is-showing');
		$( id ).addClass('is-showing');

	});


	$('.tab--close').on('click', function(e){

		e.preventDefault();

		var tabs = $(this).closest('.tabs');

		tabs.find('.tab--content').removeClass('is-showing');

	});

});